import { useCallback, useState } from 'preact/hooks';

import { usePlayer } from './PlayerProvider';
import { useJWPlayerEvent } from './useJWPlayerEvent';

export function usePlayerPip() {
  const player = usePlayer();
  const jw = player.getJWPlayer();
  const [isPip, setIsPip] = useState(Boolean(jw?.getPip()));

  const handlePipEnter = useCallback(() => {
    setIsPip(true);
  }, []);

  const handlePipLeave = useCallback(() => {
    setIsPip(false);
  }, []);

  useJWPlayerEvent('pipEnter', handlePipEnter);
  useJWPlayerEvent('pipLeave', handlePipLeave);

  const togglePip = useCallback(() => {
    jw?.setPip(!isPip);
  }, [jw, isPip]);

  return { isPip, togglePip };
}
